import type { generateDynamicColorSchemeCSS } from "@ventumsoftware/react-toolkit";
import colors from "tailwindcss/colors";

export type AppColorPalette = string | { [tint: string]: string };
export function resolveCompanyColorPalette(
  colorPalette: AppColorPalette,
): Parameters<typeof generateDynamicColorSchemeCSS>[0] {
  if (typeof colorPalette === "string") {
    if (colorPalette in colors) {
      const tailwindPalette = colors[colorPalette as keyof typeof colors];
      // Tailwind palette also includes colors like: black, white, transparent, these are unsupported for palette.
      if (typeof tailwindPalette !== "string") {
        return tailwindPalette;
      }
    }
    return colors.blue;
  }
  return colorPalette;
}
